import { observer } from 'mobx-react-lite';
import PromiseContainer from '../../../components/data/PromiseContainer';
import { Page } from '../../../components/surfaces';
import { useStore } from '../../../store';
import usePromise from '../../../store/utils/usePromise';
import SellableListToolbar from '../../products/list/components/SellableListToolbar';
import BundleTable from './BundleTable';

export default observer(function BundleListPage() {
  const { bundleStore } = useStore();
  const [bundlesPromise] = usePromise(() => bundleStore.fetchAllBundles(true));

  return (
    <Page>
      <SellableListToolbar
        createRoute="/bundles/create"
        sellableName="Bundle"
        sellables={bundlesPromise.value || undefined}
      />

      <PromiseContainer itemsName="bundles" promise={bundlesPromise}>
        {(value) => <BundleTable bundles={value.filteredItems} />}
      </PromiseContainer>
    </Page>
  );
});
